import { CircularSpinner } from '@festina-life/ui/feedback'

import { useOperationsContext } from '../../workspace/operationsContext'
import { CriticalErrors } from './CriticalErrors'
import { OperationsWithErrors } from './OperationsWithErrors'

export const LocationErrorsPanel = () => {
  const { isLoadingErrors } = useOperationsContext()

  return isLoadingErrors ? (
    <CircularSpinner className="mx-auto my-2 size-8" />
  ) : (
    <div className="p-1 flex flex-col gap-y-2">
      <CriticalErrors />
      <OperationsWithErrors variant="errors" />
    </div>
  )
}
